/**
 * pz.cart
 * 
 * Provides functionality for anything related to adding, removeing or updating the cart, including 'cart-modal'.
 * 
 * Requires: jquery
 */

$(function () {
    'use strict';

    if (window.pz === undefined) {
        window.pz = {};
    }

    pz.cart = function () {

        var initModule = function () {

            // Handle add variant to cart form submission
            $('.js-variant-container').on('submit', '.js-update-cart-form', function (event) {
                event.preventDefault();
                addVariantToCart($(event.target));
            });

            // Handle add accessory to cart form submission
            $('.js-modal-container').on('submit', '.js-update-cart-form', function (event) {
                event.preventDefault();
                addVariantToCart($(event.target));
            });

            // Handle changes to quantity on product page
            // Note: Important to target element container that does not get ajax reloaded
            $('.js-variant-container').on('change', '.js-update-cart-form .js-qty', function (event) {
                updateLineItemGroupQuantity($(event.target));
            });

            // Handle input to quantity on product page
            // Note: Important to target element container that does not get ajax reloaded
            $('.js-variant-container').on('input', '.js-update-cart-form .js-qty', function (event) {
                updateLineItemGroupQuantity($(event.target));
            });

            // Handle changes to lineitem quantity on cart
            // Note: Important to target element container that does not get ajax reloaded
            $('.js-cart-container').on('change', '.js-update-cart-form .js-qty', function (event) {
                updateLineItemGroupQuantity($(event.target));

                var $form = $('.js-update-cart-form');

                // Update cart, reload cart, update cart modal
                updateCart($form, function () {
                    // Reload cart
                    $('.js-cart-container').load('/cart');

                    // Update Cart modal
                    updateCartModal();
                });
            });

            // Handle input to lineitem quantity on cart
            // Note: Important to target element container that does not get ajax reloaded
            $('.js-cart-container').on('input', '.js-update-cart-form .js-qty', function (event) {
                updateLineItemGroupQuantity($(event.target));
            });

            // Handle cart 'remove' click and ajax reload cart
            $('.js-cart-container').on('click', '.js-cart-remove-item', function (event) {
                removeLineItemGroup($(event.target));
            });

            // Handle cart checkout button
            $('.js-cart-container').on('click', '.js-cart-checkout', function (event) {
                event.preventDefault();
                pz.viewportModal.show();
            });

            // Handle cart viewport modal login form submission
            $('.js-viewport-modal-login').on('submit', '.js-viewport-modal-login-form', function (event) {
                event.preventDefault();
                submitViewportModalSigninForm($(event.target), function () {
                    // optional callback function
                });
            });
        };

        var submitViewportModalSigninForm = function ($form, callback) {

            var data = $form.serialize();

            // submit form
            $.ajax({
                type: "POST",
                dataType: 'json',
                headers: {
                    "X-CSRF-Token": '{{ craft.app.request.csrfToken }}'
                },
                url: '',
                data: data,
                success: function (data, status, jqXHR) {
                    if (data.success) {
                        pz.viewportModal.close();
                        window.location.href="/checkout";
                        // execute callback
                        if (typeof callback === "function") callback();
                    } else {
                        // display error
                        $form.find('.js-errors').html('<div class="form__error-message error"><p>' + data.error + '</p></div>');
                        
                        // display login notice
                        $('.js-viewport-modal-login').find('.js-login-notice').css({ 'display': 'block' });
                    }
                },
                error: function (jqXHR, status, err) {
                    // TODO Need to better handle server errors (i.e. 404, etc)
                    console.log("There was a server error.");
                    console.log(err);
                }
            });
        };

        // Remove line item group
        var removeLineItemGroup = function ($element) {

            var $form = $('.js-update-cart-form');
            
            // sets the hidden 'remove' field on all items within the group.
            $element.closest('.js-line-item-group').find('.js-remove').val(1);

            // Update cart, reload cart, update cart modal
            updateCart($form, function () {
                // Reload cart
                $('.js-cart-container').load('/cart');

                // Update Cart modal
                updateCartModal();
            });
        };

        // Update line item group quantity 
        // Updates the quantity of all items in the lineitem group with 'js-match-qty' set (i.e. primary variant, add-ons, excludes one-time service fees)
        var updateLineItemGroupQuantity = function ($element) {
            var qty = $element.val();
            $element.closest('.js-line-item-group').find('.js-match-qty').val(qty);
        };

        // Add variant to cart from product page and accessories viewport modal
        var addVariantToCart = function ($form) {

            // disable add to cart button (both on product page and accessories modal)
            $(".js-add-to-cart-button").attr("disabled", true);

            // update cart
            updateCart($form, function () {
                // Show confirmation modal window
                var html = $form.find('.js-add-to-cart-msg').html();
                pz.viewportModal.load('', html);

                // Update Cart modal
                updateCartModal();
            });
        };

        // Update shopping cart badge count and reloads modal content
        var updateCartModal = function () {

            // update cart modal
            $('.js-cart-modal').load('/cart-modal', function (response, status, xhr) {
                if (status == "error") {
                    console.log("error updating cart modal");
                }

                // update cart badge count
                var itemCount = $('.js-cart-modal-list').attr('data-item-count');
                if (itemCount) {
                    // update badge
                    $('.js-cart-icon-badge').addClass('active').html(itemCount);
                } else {
                    // remove badge
                    $('.js-cart-icon-badge').removeClass('active').html('');
                }
            });
        };

        // Update cart
        // Submits the cart form via ajax and calls a callback function on success
        //
        // @param $form     object      jquery form element
        // @param callback  function    callback function
        //
        var updateCart = function ($form, callback) {

            var data = $form.serialize();

            //console.log(data);

            // submit form
            $.ajax({
                type: "POST",
                dataType: 'json',
                headers: {
                    "X-CSRF-Token": '{{ craft.app.request.csrfToken }}'
                },
                url: '',
                data: data,
                success: function (data, status, jqXHR) {
                    // TODO Need to handle craft errors - i.e. can be success with errors provided by craft.
                    // i.e. {errorCode: "invalid_credentials", error: "Invalid email or password."}
                    if (typeof callback === "function") callback();
                },
                error: function (jqXHR, status, err) {
                    // TODO Need to better handle server errors (i.e. 404, etc)
                    console.log("There was an error updating the cart.");
                    //console.log(data);
                    //console.log(err);
                    //console.log(status);
                    //console.log(jqXHR);
                }
            });
        };

        return {
            initModule: initModule
        };
    }();

    pz.cart.initModule();
});